"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const DEBUG_1 = require("@src/DEBUG");
const i0 = require("@angular/core");
const i1 = require("../events/application-events.service");
const i2 = require("../../../../../projects/angular-sdk/src/4d-mapper.service");
const i3 = require("../../../commons/map.service");
DEBUG_1.DEBUG.open('/xs/service/ui-manager');
const identify_interface_1 = require("../../interfaces/identify.interface");
const Constants_1 = require("@src/app/commons/Constants");
const rxjs_1 = require("rxjs");
const _4d_mapper_1 = require("4d-mapper");
const map_service_1 = require("@src/app/commons/map.service");
const event_listener_interface_1 = require("../../interfaces/event-listener.interface");
const application_events_service_1 = require("../events/application-events.service");
const base_class_1 = require("../../controllers/base.class");
class QuickGuideDisplay {
}
exports.QuickGuideDisplay = QuickGuideDisplay;
class XsSettings {
    constructor(name, incoming = null) {
        this.name = null;
        this.items = {};
        this.name = name;
        if (incoming) {
            Object.keys(incoming).forEach(key => {
                this.items[key] = incoming[key];
            });
        }
    }
    getToken(key) {
        return '__setting_' + this.name + '_' + key;
    }
    peek(item) {
        // console.log('## peek',item);
        if (item) {
            Object.keys(this.items).forEach(key => {
                let token = this.getToken(key);
                if (item.hasOwnProperty(token)) {
                    this.items[key] = item[token];
                    // console.log('## peek FOUND',token,item[token]);
                }
            });
        }
    }
    poke(item) {
        // console.log('## poke',item);
        if (item) {
            Object.keys(this.items).forEach(key => {
                let token = this.getToken(key);
                item[token] = this.items[key];
                // console.log('## poke POKED',token,item[token]);
            });
        }
    }
    isShowing(key) {
        if (this.items[key] && this.items[key].show) {
            return true;
        }
        return false;
    }
    setShow(key, state = true) {
        if (this.items[key]) {
            this.items[key]['show'] = state;
        }
    }
    toggleShow(key) {
        if (this.items[key]) {
            if (!this.items[key].hasOwnProperty('show')) {
                this.items[key]['show'] = false;
            }
            this.items[key]['show'] = !this.items[key]['show'];
        }
    }
}
exports.XsSettings = XsSettings;
class UiPanel extends base_class_1.XsBaseClass {
    constructor(config = {}) {
        super(config);
        this.uiManager = null;
        this.id = null;
        this.class = '';
        this.labelToken = '';
        this.show = false;
        this.items = [];
        this.controller = null;
        this.plugin = null;
        if (!this._config.id) {
            this.id = this.__uuidv4('_', 'panel_');
        }
        else {
            this.id = this._config.id;
        }
    }
}
exports.UiPanel = UiPanel;
class UiManagerService {
    constructor(applicationEvents, fourD, mapService) {
        this.applicationEvents = applicationEvents;
        this.fourD = fourD;
        this.mapService = mapService;
        this.__ID = null;
        this.__EVENTS = null;
        this.debug = Constants_1.Constants.debug_off;
        this.debugCounter = 0;
        // main mode (for advanced, normal, simple views)
        this.uiMode = 'normal';
        this.uiModeHideSimple = false;
        this.uiModeSwitch = false;
        this.uiModes = [
            { id: 'normal', labelToken: 'NAV.NORMAL_MODE', icon: 'expand' },
            { id: 'simple', labelToken: 'NAV.SIMPLE_MODE', icon: 'compress' },
            { id: 'navigator', labelToken: 'NAV.NAVIGATOR_MODE', icon: 'directions' }
        ];
        this.viewSection = new XsSettings('view', {
            // 'jobs': { labelToken:'NAV.SECTION_JOBS', show:true, icon:'expand' },
            'environment': { labelToken: 'NAV.SECTION_ENVIRONMENT', show: true, icon: 'expand' },
            'files': { labelToken: 'NAV.SECTION_FILES', show: true, icon: 'expand' },
            'bookmarks': { labelToken: 'NAV.SECTION_BOOKMARKS', show: true, icon: 'expand' },
            'photos': { labelToken: 'NAV.SECTION_PHOTOS', show: true, icon: 'expand' },
            // 'legends': { labelToken:'NAV.SECTION_LEGENDS', show:true, icon:'expand' },
            'incoming': { labelToken: 'NAV.SECTION_INCOMING', show: true, icon: 'expand' },
            'basemap': { labelToken: 'NAV.SECTION_BASEMAP', show: true, icon: 'expand' },
            'terrain': { labelToken: 'NAV.SECTION_TERRAIN', show: true, icon: 'expand' },
            'layers': { labelToken: 'NAV.SECTION_LAYERS', show: true, icon: 'expand' },
        });
        // all our UI panels
        this.panelRegistry = {}; // old
        this.panels = {};
        this.panelsActive = [];
        // short-list of only active (show) panels
        this.activePanels = [];
        // This is for all Quick Guides on the different screens
        this.toggleQuickGuide = new rxjs_1.BehaviorSubject(null);
        this.toggleQuickGuide$ = this.toggleQuickGuide.asObservable();
        this.sidebarState = {
            showCursor: false,
            showCamera: false,
            size: 0,
            oldSize: -1
        };
        DEBUG_1.DEBUG.log('/xs/service/ui-manager');
        this.__ID = identify_interface_1.XsIdentityInterface.__init(this);
        this.__EVENTS = event_listener_interface_1.XsEventListenerInterface.__init(this);
        if (this.debug) {
            console.log("%c UiManager CONSTRUCTOR()", Constants_1.Constants._yellow, this.debug);
        }
    }
    // listen out for scene changes; user props might be stored there
    ___sceneChangeProcess(scene = null) {
        if (scene) {
            this.viewSection.peek(this.mapService.currentProject.props);
        }
    }
    toggleSection(id) {
        this.viewSection.toggleShow(id);
        this.viewSection.poke(this.mapService.currentProject.props);
        this.mapService.currentProject.saveObservable().subscribe();
        // console.log('## toggle', id, this.viewSection, this.mapService.currentProject );
    }
    toggleMode() {
        let me = this;
        // slight delay to let Angular change detection catch up
        setTimeout(() => {
            if (me.uiModeSwitch) {
                me.uiMode = 'simple';
            }
            else {
                me.uiMode = 'normal';
            }
        }, 100);
    }
    switchMode(m = null) {
        const mode = '' + m; // avoid recycling incoming mode objects
        const find = this.uiModes.find(f => f.id == mode);
        if (find) {
            this.uiMode = mode;
            // console.log('## switching to', mode, this.uiModes );
        }
    }
    toggleQuickGuidePopup(screen, show) {
        this.toggleQuickGuide.next({ screen: screen, show: show });
    }
    createPanel(source, config = {}) {
        let tmp = new UiPanel(config);
        tmp.controller = source;
        this.panels[tmp.id] = tmp;
        // console.log('## panel create',tmp, config);
        return tmp;
    }
    deletePanel(panel = null) {
        if (panel && panel.id) {
            delete this.panels[panel.id];
        }
        return null;
    }
    addPanel(id = null, items = [], controller = null) {
        if (!this.panelRegistry[id]) {
            this.panelRegistry[id] = {
                id: id,
                class: '',
                label: '',
                show: false,
                items: items,
                props: [],
                plugin: controller
            };
            this.updateItems();
            if (this.debug) {
                console.log('!!!!!!!!', id, this.panelRegistry);
            }
            return this.panelRegistry[id];
        }
        return null;
    }
    removePanel(id = null) {
        if (this.panelRegistry[id]) {
            delete this.panelRegistry[id];
            this.updateItems();
        }
        return null;
    }
    updatePanels() {
        this.panelsActive = [];
        Object.keys(this.panelRegistry).forEach(key => {
            this.activePanels.push(this.panelRegistry[key]);
        });
    }
    updateItems() {
        this.activePanels = [];
        Object.keys(this.panelRegistry).forEach(key => {
            this.activePanels.push(this.panelRegistry[key]);
        });
    }
    hideAll(id = null) {
        this.activePanels.forEach(item => {
            if (id && item.id == id) {
                // do nothing
            }
            else {
                let e = document.getElementById('ui_box_' + item.id);
                if (e) {
                    e.style.display = 'none';
                }
            }
        });
    }
    showAll() {
        this.activePanels.forEach(item => {
            let e = document.getElementById('ui_box_' + item.id);
            if (e) {
                e.style.display = 'block';
            }
        });
    }
    sidebarHeightAdjust() {
        const a = this.fourD.activeUser;
        if (!a)
            return;
        this.sidebarState.showCursor = a['showCoordinates'];
        this.sidebarState.showCamera = a['showCameraCoordinates'];
        this.sidebarState.size = 15 + (this.sidebarState.showCursor ? 30 : 0) + (this.sidebarState.showCamera ? 30 : 0);
        //console.log('%c #sidebar ', Constants._red, this.sidebarState, a );
        //if ( this.sidebarState.size !== this.sidebarState.oldSize ) {
        let main = document.getElementById('sidenav');
        if (main) {
            main.style.bottom = this.sidebarState.size + 'px';
        }
        this.sidebarState.oldSize = this.sidebarState.size;
        //}
    }
}
UiManagerService.PANEL = 'panel';
UiManagerService.INFOBOX = 'infobox';
UiManagerService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function UiManagerService_Factory() { return new UiManagerService(i0.ɵɵinject(i1.XsApplicationEventsService), i0.ɵɵinject(i2.FourDService), i0.ɵɵinject(i3.MapService)); }, token: UiManagerService, providedIn: "root" });
exports.UiManagerService = UiManagerService;
